import React from "react";
import ListEditor from "../ListEditor";
import { adminApi } from "../../lib/api";
import { Label, TextInput, NumberInput, Switch, Select } from "../FormControls";
import { ICON_OPTIONS, resolveIcon } from "../../lib/iconResolver";

const CATEGORIES = ["Languages", "Frontend", "Backend", "AI / ML", "Databases", "Data", "Cloud", "DevOps", "Tools"];

const newSkill = () => ({
  name: "",
  category: "Languages",
  iconKey: "SiPython",
  icon_url: "",
  color: "#00F0FF",
  level: 80,
  visible: true,
  order: 0,
});

const Skills = () => (
  <ListEditor
    resource={adminApi.skills}
    resourceKey="skills"
    title="Skills"
    description="Powers the live marquee. Change category to regroup; reorder to control marquee rows."
    newItem={newSkill}
    searchFields={["name", "category"]}
    renderRow={(s) => {
      const Icon = resolveIcon(s.iconKey);
      return (
        <div className="flex items-center gap-3 min-w-0">
          <div
            className="w-8 h-8 rounded-lg border border-white/10 bg-white/[0.03] grid place-items-center"
          >
            <Icon size={16} style={{ color: s.color || "#00F0FF" }} />
          </div>
          <div className="min-w-0">
            <div className="text-white font-medium truncate">{s.name}</div>
            <div className="text-xs text-slate-500 truncate">{s.category} · level {s.level}</div>
          </div>
        </div>
      );
    }}
    renderForm={(d, set) => {
      const Icon = resolveIcon(d.iconKey);
      return (
        <>
          <div className="grid sm:grid-cols-2 gap-3">
            <div>
              <Label>Name</Label>
              <TextInput value={d.name} onChange={(v) => set("name", v)} placeholder="Python" />
            </div>
            <div>
              <Label>Category</Label>
              <Select value={d.category} onChange={(v) => set("category", v)} options={CATEGORIES} />
            </div>
          </div>
          <div className="grid sm:grid-cols-2 gap-3">
            <div>
              <Label>Icon</Label>
              <Select value={d.iconKey} onChange={(v) => set("iconKey", v)} options={ICON_OPTIONS} />
            </div>
            <div>
              <Label>Color (hex)</Label>
              <TextInput value={d.color} onChange={(v) => set("color", v)} placeholder="#3776AB" />
            </div>
          </div>
          <div className="flex items-center gap-3 p-3 rounded-xl glass">
            <Icon size={26} style={{ color: d.color || "#00F0FF" }} />
            <div className="text-sm text-white">{d.name || "Preview"}</div>
          </div>
          <div className="grid sm:grid-cols-2 gap-3">
            <div>
              <Label>Skill level (0-100)</Label>
              <NumberInput value={d.level} onChange={(v) => set("level", v)} min={0} max={100} />
            </div>
            <div>
              <Label>Order</Label>
              <NumberInput value={d.order} onChange={(v) => set("order", v)} />
            </div>
          </div>
          <Switch value={d.visible} onChange={(v) => set("visible", v)} label="Visible on site" />
        </>
      );
    }}
  />
);

export default Skills;
